// classnames which are used for direct DOM querying during PDF generation

export const PAGE_WRAPPER_TITLE_CLASSNAME = 'pageWrapperTitle'
export const SECTION_HEADER_CONTAINER_CLASSNAME = 'sectionHeaderContainer'
export const CARD_LIST_ITEM_CLASSNAME = 'cardListItem'
